__turbopack_context__.v({
  "roomCheckbox": "styles-module__waV5Tq__roomCheckbox",
  "roomLabel": "styles-module__waV5Tq__roomLabel",
  "roomOption": "styles-module__waV5Tq__roomOption",
  "roomOptionMobile": "styles-module__waV5Tq__roomOptionMobile",
  "roomOptionSelected": "styles-module__waV5Tq__roomOptionSelected",
  "roomOptions": "styles-module__waV5Tq__roomOptions",
  "roomOptionsMobile": "styles-module__waV5Tq__roomOptionsMobile",
  "roomSelection": "styles-module__waV5Tq__roomSelection",
  "title": "styles-module__waV5Tq__title",
});
